export { Illustration } from './Illustration';
